export interface CarouselSlide {
  id: string;
  image: string;
  alt: string;
  eyebrow: string;
  title: string;
  description: string;
  primaryCta: string;
  secondaryCta: string;
  isPrimaryHeading?: boolean;
}

export const heroImages: CarouselSlide[] = [
  {
    id: "1",
    image: "/Office%20Furniture/home2-slider1.webp",
    alt: "أثاث YUMA - مجموعة راقية",
    eyebrow: "يوما – YUMA",
    title: "اختيارك المفضل.. في كل زاوية",
    description:
      "نًصنع جميع أنواع الأثاث المصمم خصيصًا لكِ ",
    primaryCta: "تسوق الآن",
    secondaryCta: "استعرض الكتالوج",
    isPrimaryHeading: true,
  },
  {
    id: "2",
    image: "/Office%20Furniture/home2-slider2.webp",
    alt: "أثاث YUMA - تصاميم حديثة",
    eyebrow: "أناقة بيتكِ تُروى في كل تفصيلة",
    title: "تصاميم تناسب كل المساحات",
    description: "قطع أثاث تلبي كل احتياجات منزلك",
    primaryCta: "تسوق الآن",
    secondaryCta: "استعرض الكتالوج",
  },
  {
    id: "3",
    image: "/Office%20Furniture/home2-slider3.webp",
    alt: "أثاث YUMA - خامات مختارة",
    eyebrow: "تفاصيل تندمج مع أسلوب حياتك",
    title: "حيث يهدأُ العالم وتبدأُ راحتكِ",
    description: "خامات مختارة بعناية بتصميم عملي وأناقة تدوم معك.",
    primaryCta: "تسوق الآن",
    secondaryCta: "استعرض الكتالوج",
  },
];
